import accounting from 'accounting'

export default {
  toMoney: money => `${money.currency} ${accounting.formatMoney(money.amount)}`
}
